export const ExternalSwitches = {
  IOS_PARENT_SIGNUP_DEFERRED_DEEPLINK: "iOS_parentSignUpDeferredDeepLinkv4",
  WEB_EXTERNAL_JOIN_MENTOR_SURVEY: "web_external_JoinMentorSurvey",
  IOS_PARENT_SIGNUP_DEFERRED_DEEPLINK_CLASS: "iOS_parentSignUpDeferredDeepLinkClass",
  WEB_HOMEPAGE_TAGLINE_2023: "web_homepage_tagline_2023",
  WEB_LOGGEDOUT_A_A_TEST: "web_loggedout_a_a_test",
  WEB_EXTERNAL_PARENT_REDIRECT_LOGIN: "web_external_parent_redirect_login",
  WEB_EXTERNAL_TEACHER_REDIRECT_LOGIN: "web_external_teacher_redirect_login",
  WEB_EXTERNAL_PREFILL_RECOVER_EMAIL: "web_external_prefill_recover_email_v2",
  WEB_ATTRIBUTION_SURVEY: "web_attribution_survey",
} as const;

export const featureSwitches = Object.values(ExternalSwitches);
